import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Paper, Typography, Divider, Stack } from '@mui/material';
import PaymentsIcon from '@mui/icons-material/Payments';
import RenewalPaymentFlow from '../../billing/RenewalPaymentFlow';

/**
 * Public (login gerektirmeyen) yenileme/tahsilat ödeme sayfası — /pay/renewal/:token.
 *
 * Ödeme akışının çekirdeği paylaşılan RenewalPaymentFlow bileşenindedir; bu sayfa
 * yalnızca tam sayfa "chrome"u (başlık + kart) sağlar. E-postadaki bağlantı buraya
 * gelir ve PayTR iframe'i ikinci tıklama olmadan açılır. Panel içi ödeme popup'ı
 * (LicensePaymentDialog) aynı çekirdeği dialog içinde, özet + buton olarak kullanır.
 */
const PublicRenewalPayment: React.FC = () => {
  const { token } = useParams<{ token: string }>();

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'grey.100', py: { xs: 2, md: 6 }, px: 2 }}>
      <Paper sx={{ maxWidth: 720, mx: 'auto', p: { xs: 2, md: 4 } }}>
        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 1 }}>
          <PaymentsIcon color="primary" sx={{ fontSize: 32 }} />
          <Typography variant="h5" sx={{ fontWeight: 700 }}>Yenileme / Tahsilat</Typography>
        </Stack>
        <Typography color="text.secondary" sx={{ mb: 2 }}>
          Aşağıdaki hizmetlerin ödemesini güvenli şekilde tamamlayabilirsiniz.
        </Typography>
        <Divider sx={{ mb: 2 }} />
        {token ? (
          <RenewalPaymentFlow token={token} autoStart />
        ) : (
          <Typography color="error">Geçersiz bağlantı.</Typography>
        )}
      </Paper>
    </Box>
  );
};

export default PublicRenewalPayment;
